export default __webpack_public_path__ + "static/TransitRevitalizationInvestmentDistrictTRID-375f8675c07a2f098b383754556be325.png";